@if (mail) {

  <div class="mail-data" [attr.data-testing-id]="mail.id + '-mail-pannel'">
    <div class="top-row">
      <div class="sender" [attr.data-testing-id]="mail.id + '-mail-sender'">
        From: {{ mail.data.from }}
      </div>
      <div class="date" [attr.data-testing-id]="mail.id + '-mail-date'">
        {{ mail.creationTime | date:'dd.MM.yy h:mm' }}
      </div>
    </div>
    <div class="mail-subject" [attr.data-testing-id]="mail.id + '-mail-subject'">
      Subject: {{ mail.data.emailContent.subject }}
    </div>
    <div class="bottom-row">
      <div class="text" [attr.data-testing-id]="mail.id + '-mail-text'">
        {{ mail.data.emailContent.txtBody}}
      </div>
      @if(workbenchCommandRegistry) {
        <div class="icon" >
          <fa-icon (click)="openMail(mail.id)" pTooltip="Open Mail" [icon]="externalLink"
                   [attr.data-testing-id]="mail.id + '-open-mail'"></fa-icon>
        </div>
      }
    </div>
  </div>
} @else {
<!--  TODO spinner-->
}
